/**
 * @file useSelectDisplayInfo
 */
import { useEffect } from 'react';
import { useUpdate } from '@tencent/glue-react-use';
import { useSelectInstance } from '../context/select';
export function useSelectDisplayInfo() {
  var select = useSelectInstance();
  var update = useUpdate();
  useEffect(function () {
    select.addListener('select-option-update', update);
    return function () {
      select.removeListener('select-option-update', update);
    };
  }, []);
  return select.getDisplayInfo();
}